import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { ProductsReport } from './products-report';
import { v2Component } from '../../../index';

export function initProductsReport() {
  document.getElementsByName('products-report').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ProductsReport {...dataset} />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
